import Slider from "react-slick";
import styled, { css, keyframes } from "styled-components";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import setInsideFocusOutline from "../../../utils/setInsideFocusOutline";
import space, { spaceFactor } from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import { StyledArrow } from "../../organisms/ItemsSliderContainerOrg/ItemsSliderContainerOrg.styled";
var borderRadiusSize = "huge";
var dotsHeight = 12;
var activeDotWidth = 40;
var dotsMarginSpace = 2;
var arrowHeightSpace = 10;
export var StyledSlider = styled(Slider).withConfig({
  componentId: "sc-19xm5xa-0"
})(["position:relative;width:100%;margin:0 auto;.focusable-slide-wrapper{position:relative;}.focusable-slide-wrapper:focus{", "}.slick-slide{width:100%;}.slick-list{width:100%;}&:hover{.slick-arrow{opacity:1;}}.slick-arrow{", ";position:absolute;z-index:1;top:calc( 50% - (", " + ", ") );transform:translateY( calc(-1 * ", " / 2) );opacity:0;&.slick-prev{left:0;}&.slick-next{right:0;}}"], setInsideFocusOutline(), transition("opacity"), unit(dotsHeight), unit(dotsMarginSpace * spaceFactor / 2), unit(arrowHeightSpace * spaceFactor));
export var setSliderIndicatorsStyle = function setSliderIndicatorsStyle(theme) {
  return css(["border-radius:", ";background-color:", ";box-shadow:", ";backdrop-filter:blur(", ");padding:", " ", ";"], getBorderRadius(theme, "mlarge"), getColor(theme, "white", "default", 0.8), getBoxShadow(theme, "nano"), unit(5), space(0.5), space(1.5));
};
export var SliderIndicators = styled.div.withConfig({
  componentId: "sc-19xm5xa-1"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;justify-content:center;align-items:center;gap:", ";position:absolute;bottom:", ";left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);", ";"], space(1), space(1), setSliderIndicatorsStyle(theme));
});
export var SliderDots = styled.ul.withConfig({
  componentId: "sc-19xm5xa-2"
})(["display:flex;gap:", ";list-style-type:none;"], space(1));
export var SliderDot = styled.button.withConfig({
  componentId: "sc-19xm5xa-3"
})(function (_ref2) {
  var $isActive = _ref2.$isActive,
    theme = _ref2.theme;
  return css(["display:block;height:", ";width:", ";margin:", ";border:0;border-radius:", ";background-color:", ";font-size:0;cursor:pointer;position:relative;overflow:hidden;", ""], unit(dotsHeight), unit(dotsHeight), space(0.5), getBorderRadius(theme, borderRadiusSize), getBorderColor(theme, "white", "low"), $isActive ? css(["width:", ";cursor:default;"], unit(activeDotWidth)) : css(["&:hover{background-color:", ";}"], getBorderColor(theme, "white", "medium")));
});
var progressBarAnimation = keyframes(["from{width:0;}to{width:", ";}"], unit(activeDotWidth));
export var ProgressBar = styled.div.withConfig({
  componentId: "sc-19xm5xa-4"
})(function (_ref3) {
  var $isStopped = _ref3.$isStopped,
    $time = _ref3.$time,
    theme = _ref3.theme;
  return css(["position:absolute;left:0;top:0;background-color:", ";height:", ";", ""], getColor(theme, "backgroundBlack"), unit(dotsHeight), !$isStopped ? css(["animation:", " ", "ms ease-in-out;animation-fill-mode:forwards;"], progressBarAnimation, $time) : css(["width:100%;"]));
});
export var PlayIcon = styled.div.withConfig({
  componentId: "sc-19xm5xa-5"
})(function (_ref4) {
  var theme = _ref4.theme;
  return css(["display:flex;&:hover{cursor:pointer;& svg{fill:", ";& path{fill:", ";}}}"], getColor(theme, "backgroundBlack"), getColor(theme, "backgroundBlack"));
});
export var PrevArrowButton = styled(StyledArrow).withConfig({
  componentId: "sc-19xm5xa-6"
})(["margin-left:", ";"], space(1));
export var NextArrowButton = styled(StyledArrow).withConfig({
  componentId: "sc-19xm5xa-7"
})(["margin-right:", ";"], space(1));